import { useDispatch, useSelector } from 'react-redux';

import { coreSettingsSelector, shoppingCartSelector } from '~screens/Dashboard/screens/Home/redux/selectors';
import { actionCreators as homeActions } from '~screens/Dashboard/screens/Home/redux/actions';
import giftCardActions from '~redux/GiftCards/actions';
import { removeByIndex } from '~utils/array';

export const useGiftCard = ({ item, index }) => {
  const dispatch = useDispatch();
  const { items } = useSelector(shoppingCartSelector);
  const { giftCardsDiscountTitle } = useSelector(coreSettingsSelector);
  const { shoppingCartLoading } = useSelector(state => state.home);

  const onModify = () => dispatch(giftCardActions.editGiftCard({ isEditing: true, index, ...item }));

  const onRemove = () => {
    dispatch(homeActions.getCartPrices(removeByIndex(items, index)));
  };

  return {
    loading: shoppingCartLoading,
    onModify,
    onRemove,
    giftCardsDiscountTitle
  };
};
